import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import React from 'react';
import checkIcon from '../../../assets/images/circle-check.png';
import './styles.css';
import { sxCloseIconButton, sxTypographySubTitleModal, sxTypographyTitleModal } from './sxProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';


const ModalAtendimentoConfirmado: React.FC<{showModal: boolean; handleShowModal: () => void;}> = ({ showModal, handleShowModal }) => {

    const accessibility = useAccessibility();

    return (
        <div>
            <Modal
                open={showModal}
                onClose={handleShowModal}
            >
                <div className='container-schedule-modal' style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }} >
                    <IconButton
                        aria-label="close"
                        onClick={handleShowModal}
                        sx={sxCloseIconButton}
                    >
                        <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faTimes} size="1x" color='black' />
                    </IconButton>
                    <div>
                        <img src={checkIcon} alt="Icone de confirmacao." />
                    </div>
                    <div>
                        <Typography style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxTypographyTitleModal}>Confirmado</Typography>
                        <Typography style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxTypographySubTitleModal}>Seu atendimento foi confirmado com sucesso!</Typography>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ModalAtendimentoConfirmado;
